
  document.addEventListener('DOMContentLoaded', function () {
    function updateCartTotalWeight() {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const weightContainer = document.getElementById('CartTotalWeight');

          // If the cart has products and the weight is greater than 0
          if (cart.item_count > 0 && cart.total_weight > 0) {
            const weight = (cart.total_weight >= 1000)
              ? (cart.total_weight / 1000).toFixed(2) + ' kg'
              : cart.total_weight + ' g';

            // Update or create a new one if it doesn't exist.
            if (weightContainer) {
              weightContainer.textContent = 'Cart Total Weight: ' + weight;
              weightContainer.style.display = 'block'; // show
            } else {
              const newDiv = document.createElement('div');
              newDiv.id = 'CartTotalWeight';
              newDiv.className = 'cart-total-weight';
              newDiv.textContent = 'Cart Total Weight: ' + weight;
              //Add to the location you want to display
              const cartFooter = document.querySelector('.cart__footer');
              if (cartFooter) {
                cartFooter.appendChild(newDiv);
              }
            }
          } else {
            // If the product is no longer available, hide or delete it.
            if (weightContainer) {
              weightContainer.remove();
            }
          }
        })
        .catch(error => {
          console.error("Error when getting cart: ", error);
        });
    }

    // Listen for event when product is deleted
    document.addEventListener('click', function (e) {
      if (e.target.closest('.cart__remove')) {
        setTimeout(updateCartTotalWeight, 700); // Wait for Shopify to process the deletion
      }
    });

    // Update as soon as page loads
    updateCartTotalWeight();
  });

